import { Box, Button, Typography } from '@mui/material'
import FormHelper from '../helpers/FormHelper'
import './style.scss'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

function Overview ({ quote, apr, tcredit, trepay, mrepay, excerpt, interval, setQuote, setId }) {
  const handleRecalculate = () => {
    setQuote('')
  }
  const intervalText = FormHelper.Interval[interval - 1]
  return <>
    <Box className="calc-overview-wrapper ">
      <Typography variant="h6">ID / quote number</Typography>
      <Typography variant="h2">{quote}</Typography>
      <Typography variant="h6" className="calc-overview-grid-title">Loan Overview</Typography>
      <Box className="calc-overview-grid">
        <Box className="calc-overview-row calc-overview-mr">
          <Typography component="p" variant="body1">{intervalText} Repayment</Typography>
          <Typography variant="h6">{FormHelper.moneyFormatter.format(mrepay)}</Typography>
        </Box>
        <Box className="calc-overview-row">
          <Typography component="p" variant="body2">APR</Typography>
          <Typography variant="h6">{apr}%</Typography>
        </Box>
        <Box className="calc-overview-row">
          <Typography component="p" variant="body2">Total Cost of Credit</Typography>
          <Typography variant="h6">{FormHelper.moneyFormatter.format(trepay)}</Typography>
        </Box>
        <Box className="calc-overview-row">
          <Typography component="p" variant="body2">Total to Repay</Typography>
          <Typography variant="h6">{FormHelper.moneyFormatter.format(tcredit)}</Typography>
        </Box>
      </Box>
      <Typography variant="body2" component="p">{excerpt}</Typography>
      <Button className="calc-button-arrow"
              startIcon={<ArrowBackIcon />}
              onClick={handleRecalculate}
      >Recalculate</Button>
    </Box>
  </>
}

export default Overview
